























import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import { DxTextBox } from 'devextreme-vue/ui/text-box';
import ImbalanceCell from './NebalansCell.vue';

@Component({
  name: 'Nebalans',
  components: {
    DxTextBox,
    ImbalanceCell
  }
})
export default class extends Vue {
  @PropSync('imbalance') public imbalanceData!: any;
  @Prop() public cutName!: string;
  @Prop() public colorKey!: string;

}
